enum DeviceOS {
  Android = 'Android',
  iOS = 'iOS',
  other = 'other',
}

export default DeviceOS;
